export const FEATURED_BOOK = "filters/featuredbook";
export const SEARCH_KEYWORD = "filters/searchkeyword";
